import styled from '@emotion/styled'
import { Chip, Select } from '@mui/material'
import theme from 'theme'

export const StyledChip = styled(Chip)`
  height: 48px;
  padding: ${theme.spacing.xMd}px ${theme.spacing.small}px;
  border: 1px solid ${theme.colors.dropdownBorder};
  border-radius: ${theme.spacing.md}px;

  background-color: ${theme.colors.labelCardBg};
  color: ${theme.colors.cta};

  &.clipped-chip {
    max-width: 49%;

    .chip-label-content {
      max-width: 150px;
    }
  }

  &.select-item-chip {
    width: 100%;
    justify-content: space-between;
    background-color: transparent;

    .chip-label-content {
      max-width: 100%;
    }
  }

  .MuiChip-label {
    padding: 0;
    font-size: ${theme.typography.fontSize.large};

    .chip-label {
      display: flex;
      align-items: center;
      gap: ${theme.spacing.half}px;

      .chip-label-prefix {
        color: ${theme.colors.dropdownLabel};
        font-weight: ${theme.typography.fontWeight.extraThick};

        html[data-theme='light'] & {
          color: ${theme.colors.caption};
        }
      }

      .chip-label-content {
        margin-right: ${theme.spacing.md}px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  .MuiChip-deleteIcon {
    color: ${theme.colors.menuItemText};
    font-size: ${theme.iconSize.xxSmall}px;
    margin-right: ${theme.spacing.half}px;

    &:hover {
      color: ${theme.colors.cta};
    }
  }
`

export const StyledSelect = styled(Select)`
  height: 48px;

  .MuiSelect-select {
    display: flex;
    justify-content: space-between;
    align-items: center;

    min-width: 32px;
    height: 100%;
    padding: 0 ${theme.spacing.small}px;
    box-sizing: border-box;
    border: 1px solid ${theme.colors.dropdownBorder};
    border-radius: ${theme.attributes.borderRadius.tertiary};

    font-size: ${theme.typography.fontSize.large};
    color: ${theme.colors.cta};
    background-color: ${theme.colors.labelCardBg};
  }

  .MuiOutlinedInput-notchedOutline {
    border: none;
  }

  &.Mui-focused .MuiSelect-select {
    border: 1px solid ${theme.colors.dropdownBorder};
  }

  svg {
    color: ${theme.colors.devicesSecondaryText};
    transition: transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  }
`
